<template>
  <div>
    <ClientEditModal id="editClientModal" :client="client" @ok="getClient"></ClientEditModal>

    <b-card header-tag="header" footer-tag="footer" class="shadow w-md-50 mb-3">
      <template v-slot:header>
        <h4
          class="m-0 font-weight-bold text-site-primary"
        >Client {{ id }} -  {{ client && client.user ? client.user.username : '' }}</h4>
      </template>

      <!-- Controls -->
      <b-card-text>
        <b-card-group class="children-mr-2">
          <b-button
            v-b-modal.editClientModal
            variant="primary"
            size="sm"
            class="bg-site-primary"
          >Edit Client</b-button>
        </b-card-group>
      </b-card-text>
    </b-card>

    <!-- Credit Groups -->
    <CreditGroupList
      :clientId="id"
      :restrictedMode="false"
    ></CreditGroupList>

    <!-- Examinees -->
    <ExamineeList
      :clientId="id"
      :restrictedMode="false"
    ></ExamineeList>
  </div>
</template>

<script>
import ClientEditModal from "./ClientEditModal";
import CreditGroupList from "./CreditGroupList"
import ExamineeList from "../client/ExamineeList";
export default {
  name: `ClientView`,
  components: {
    ClientEditModal,
    CreditGroupList,
    ExamineeList,
  },
  props: {
    id: {
      type: String,
    },
  },
  data() {
    return {
      client: null,
      examineeList: null,
    };
  },
  computed: {
    nonActiveExamineeCount() {
      let examineeList = this.examineeList || [];
      var count = 0;
      examineeList.forEach((examinee) => {
        if (examinee.status == `created`) count++;
      });
      return count;
    },
  },
  mounted() {
    this.getClient();
  },
  methods: {
    getClient() {
      const id = this.id;
      if (!id || isNaN(id)) {
        this.$router.push("../");
      } else {
        this.$store
          .dispatch("client/get", { id })
          .then((data) => (this.client = data.data));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>